/*
 * @Description: 多个签到地址
 * @Author: jsh
 * @Date: 2022-11-16 10:08:10
 * @LastEditTime: 2022-11-25 10:30:20
 * @LastEditors: cxh
 */
import type{ AddressArrValidate } from '@/typings/api/clueManage'
const checkAddressValidate = (rule: any, value: number | string, arr: any, name: string, message: string) => {
  const index = rule.field.split('.').slice(-2)[0] * 1
  const list = arr || []
  const key = list[index][name]

  if (list.filter((item: any) => item.addressTag === 1223).length > 1) {
    return Promise.reject(new Error('地址类型【总部（决策地）】只能选择1个'))
  }

  // 当选择“签到地址”时不需要校验“标签”
  if (name === 'addressName' || key === -9) {
    return Promise.resolve()
  }

  if (key != null && key !== '' && (!value || value === -9)) {
    return Promise.reject(new Error(message))
  } else {
    return Promise.resolve()
  }
}

const checkAddressData = (data?:AddressArrValidate[]) => {
  console.log('data: ', data)
  // const arr = data.filter((s) => {
  //   return s.addressName
  // })
  const haveSame = !!data?.some((cur, idx:number, array) => array.slice(idx + 1).find(item => {
    if (item.addressName) {
      return cur.addressName === item.addressName
    } else {
      return false
    }
  }))
  return haveSame
}
const handleAddressAdd = (data?:AddressArrValidate[]) => {
  if (data && data.length >= 5) {
    return
  }
  data?.push({ addressTag: undefined, addressName: undefined, geoPoint: undefined })
}
const handleAddressAddDel = (index: number, data?:AddressArrValidate[]) => {
  data?.splice(index, 1)
}
const clear = (arr: any[], keys: string[]) => {
  if (!arr) {
    return []
  }
  let result: any = []
  arr.forEach((v: any) => {
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i]
      if (v[k] != null && v[k] !== '') {
        result.push(v)
        break
      }
    }
  })
  if (!result.length) {
    result = [{}]
  }
  return result
}
export { checkAddressValidate, checkAddressData, handleAddressAdd, handleAddressAddDel, clear }
